import React from 'react';
import styles from './DesktopMediaFilter.module.scss';
import BaseMediaFilter from './BaseMediaFilter';

const DesktopMediaFilter = () => <BaseMediaFilter styles={styles} />;

export default DesktopMediaFilter;
